import { Component, ChangeDetectorRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-otras-solicitudes-acomp',
  templateUrl: './otras-solicitudes-acomp.component.html',
  styleUrls: ['./otras-solicitudes-acomp.component.css'],
  providers: [FormService]
})
export class OtrasSolicitudesAcompComponent {

  public form;
  public formulario;

  public form131 = false;
  public form132 = false;


  public rows = [];
  public actualRow;
  public valor;


  constructor(private _changeDetectionRef: ChangeDetectorRef) {


    this.form = localStorage.getItem("form")


    if (this.form == "1-3.1") {
      this.form131 = true
    }
    if (this.form == "1-3.2") {
      this.form132 = true
    }

    this.formulario = new FormGroup({
      numero_otros1: new FormControl('', [Validators.pattern(/^[0-9]\d*$/)]), //demolicion
      fecha_otros1: new FormControl(''),
      numero_otros2: new FormControl('', [Validators.pattern(/^[0-9]\d*$/)]), //otros
      fecha_otros2: new FormControl(''),
    })

    if (!JSON.parse(localStorage.getItem("otrasSolicitudesAcomp"))) {
      localStorage.setItem("otrasSolicitudesAcomp", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("otrasSolicitudesAcomp"));

      this.formulario.controls['numero_otros1'].setValue(this.rows[0] ? this.rows[0].numero_otros1 : '')
      this.formulario.controls['fecha_otros1'].setValue(new Date(this.rows[0] ? this.rows[0].fecha_otros1 : ''))
      this.formulario.controls['numero_otros2'].setValue(this.rows[0] ? this.rows[0].numero_otros2 : '')
      this.formulario.controls['fecha_otros2'].setValue(new Date(this.rows[0] ? this.rows[0].fecha_otros2 : ''))
    }

  }

  add_otros() {


    localStorage.setItem("otrasSolicitudesAcomp", JSON.stringify([]));
    this.actualRow = localStorage.getItem("otrasSolicitudesAcomp");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      numero_otros1: this.formulario.value.numero_otros1,
      fecha_otros1: this.formulario.value.fecha_otros1 ? moment(this.formulario.value.fecha_otros1).format('DD/MM/YYYY') : "",
      numero_otros2: this.formulario.value.numero_otros2,
      fecha_otros2: this.formulario.value.fecha_otros2 ? moment(this.formulario.value.fecha_otros2).format('DD/MM/YYYY') : "",

    })
    localStorage.setItem("otrasSolicitudesAcomp", JSON.stringify(this.rows));


  }

}
